import axios from 'axios';
import loadingAnimation from '../loading-animation.vue';
import axiosError from '../axios-error.vue';
import scrollTo from '../../coto_scripts/functions/scroll-to';
import slideshow from '../../coto_scripts/slideshow/slideshow';
import getHeight from '../../coto_scripts/functions/get-height';
import cartOptions from '../../coto_scripts/cart/cart-slide';

export default {
  name: 'delDiaChoice',
  components: {
    loadingAnimation,
    axiosError,
  },
  props: ['productID', 'productPronounce', 'comparePrice'],
  data() {
    return {
      loading: true,
      refreshing: false,
      error: false,
      products: null,
      backorder: false,
      soldout: false,
      choiceImages: null,
      choiceID: null,
      choicePrice: '',
      featuredImage: null,
      mobile: true,
      shuffleButtonText: 'Shuffle Colors',
      firstRefresh: true,
    };
  },
  methods: {
    loadSlideshow() {
      slideshow();
    },
    resetChoiceSlideshow(index) {
      let $item = document.querySelectorAll('.item')[index],
        $slideshow = $item.querySelector('.coto_slideshow'),
        $button = $slideshow.querySelectorAll('.pagination-button'),
        $activeButton = $slideshow.querySelector('.active'),
        $slide = $slideshow.querySelectorAll('.coto_slide'),
        $activeSlide = $slideshow.querySelector('.current-slide');

      $activeButton.classList.remove('active');
      $activeSlide.classList.remove('current-slide');
      $button[0].classList.add('active');
      $slide[0].classList.add('current-slide');
    },
    setSliderClasses(obj, sibling) {
      obj.classList.add('slide-in');
      sibling.classList.add('slide-out');

      setTimeout(function () {
        obj.classList.remove('slide-in');
        obj.classList.add('active');
        sibling.classList.remove('active');
        sibling.classList.remove('slide-out');
      }, 500);
    },
    slider(event) {
      let $nav = document.querySelector('.slider-nav'),
        $obj = event.target,
        $item = document.querySelectorAll('.item'),
        $sibling = $item[0],
        isActive = $obj.classList.contains('selected'),
        index = [...$obj.parentElement.children].indexOf($obj);

      if (!isActive) {
        if (index == 0) {
          $sibling = $item[1];
          setTimeout(() => {
            this.resetChoiceSlideshow(1);
          }, 400);
        } else {
          if ($item[2]) {
            $sibling = $item[2];
          }
          if (!$item[1].classList.contains('loaded')) {
            this.loadSlideshow();
          }
        }

        $nav.querySelector('.selected').classList.remove('selected');
        $obj.classList.add('selected');

        this.setSliderClasses($item[index], $sibling);
        this.featuredImage = this.products.images[0].src;
        setTimeout(() => {
          this.choiceID = null;
        }, 300);
      }
    },
    openChoice(product) {
      this.choiceImages = product.images;
      this.choiceID = product.variantId;
      this.featuredImage = product.images[0].src;
      this.choicePrice = product.price;

      scrollTo(document.getElementById('options'));
      setTimeout(() => {
        // if(typeof affirm !== 'undefined'){
        // 	affirm.ui.refresh();
        // }
        let $item = document.querySelectorAll('.item');
        this.setSliderClasses($item[2], $item[0]);
        this.loadSlideshow();
      }, 75);
    },
    closeChoice() {
      let $item = document.querySelectorAll('.item'),
        $slideshow = $item[2].querySelector('.coto_slideshow'),
        isLoaded = $slideshow.classList.contains('loaded');

      this.setSliderClasses($item[0], $item[2]);

      setTimeout(() => {
        this.choiceID = null;
      }, 400);
    },
    addToCart(event) {
      let $obj = event.target,
        productID = $obj.dataset.id;

      vueSideCart.addItem(productID, 1, {
        _imgUrl: this.featuredImage,
        _saleStatus: 'Current',
      });

      //this.dynamicYieldaddToCartEvent(this.selectedVariant);
    },
    refreshGrid() {
      this.refreshing = true;
      var refreshGridButton = document.getElementById('choiceRefreshButton');
      if (refreshGridButton) {
        this.shuffleButtonText = 'Hold Your Llamas';
        refreshGridButton.disabled = true;
      }
      if (window.location.href.includes('development.cotopaxi')) {
        //console.log('dev site detected. Use prod data.')
        this.productID = 10010681930; //have dev grab from prod for now.
      }
      axios
        .get(
          `https://production-access-api.cotopaxi.com/choice/getChoiceItemsGridByProductId/${this.productID}`
        )
        .then((response) => {
          this.products = response.data;
          //console.log(parseInt(this.products.price) * 100 > 4900);
          // if(typeof affirm !== 'undefined' && affirm.ui.refresh() === 'function'){ //check if affirm is blocked by adblocker
          // 	affirm.ui.refresh();
          // }
          this.loading = false;
          this.refreshing = false;
          this.featuredImage = response.data.images[0].src;

          if (response.data.inventoryCount <= 0) {
            if (response.data.backorderMessage) {
              this.backorder = true;
            } else {
              this.soldout = true;
            }
          }

          if (this.products.choiceItems.length < 20) {
            setTimeout(() => {
              this.loadSlideshow();
            }, 200);
          }

          //delay enabling refresh button for 5 seconds
          setTimeout(() => {
            if (refreshGridButton) {
              this.shuffleButtonText = 'Shuffle Colors';
              refreshGridButton.disabled = false;
            }
          }, 5000);
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.refreshing = false;
          this.shuffleButtonText = 'Shuffle Colors';
          if (refreshGridButton) {
            refreshGridButton.disabled = false;
          }
          // if(!error.includes('affirm')){
          this.error = true;
          //}
        });
    },
    priceFilter(price) {
      //let value = price.replace(/\.00$/, '');
      //had to edit this so that it either has 2 decimals or none (single decimal was breaking sezzle)
      if (price.includes('.00')) {
        return price.replace(/\.00$/, '');
      } else {
        return parseFloat(price).toFixed(2);
      }
    },
    compareFilter(price) {
      let formattedPrice = (price / 100).toString();
      return formattedPrice;
    },
  },
  created() {
    this.refreshGrid();

    if (document.documentElement.clientWidth > 768) {
      this.mobile = false;
    }

    //set certain products to default to wildcard variant instead of choice grid. (for promos)
    // if(this.firstRefresh === true && this.productID == "11942166346"){
    // 	//trigger a click event on the surpsise me button
    // 	this.firstRefresh = false;
    // 	var checkExist = setInterval(function() {
    // 		if (document.getElementById('surpriseMeButton')) {
    // 		   document.getElementById('surpriseMeButton').click();
    // 		   clearInterval(checkExist);
    // 		}
    // 	 }, 100);
    // }

    // get url params
    const queryString = window.location.search;
    // using new interface to search/get params
    const urlParams = new URLSearchParams(queryString);
    // for now we can just check if feed is defined, as only google feed will have this.
    let hasFeedParam = urlParams.has('feed');

    // check URL params to click into surpise me when a user drops in from the google feed.
    if (this.firstRefresh === true && hasFeedParam) {
      //trigger a click event on the surpsise me button
      this.firstRefresh = false;
      var checkExist = setInterval(function () {
        if (document.getElementById('surpriseMeButton')) {
          document.getElementById('surpriseMeButton').click();
          clearInterval(checkExist);
        }
      }, 100);
    }
  },
};
